// Reuse FLYOUT's popup, blocks, editor events and positioning.
customElements.whenDefined('promo-popup').then(() => {
  if (customElements.get('fly-banner')) return;

  class Flybanner extends customElements.get('promo-popup') {
    constructor() {
      super();
      this.dismissalCookie = `flybanner-dismissed-${this.dataset.sectionId}`;
      this.cookieName = `flybanner-auto-${this.dataset.sectionId}`;
      this.dismissedUntil = 0;
      this.scrollIntentUntil = 0;
      this.onScrollIntent = this.onScrollIntent.bind(this);
    }

    init() {
      if (Shopify?.designMode || this.dataset.autoOpen !== 'true' || this.isDismissed() || this.hasPopupedUp) return;

      // A layout shift or restored scroll position must not open the banner.
      this._scrollDelayPercent = parseInt(this.dataset.delay.replace('scrolling_', ''), 10) / 100;
      if (!Number.isFinite(this._scrollDelayPercent)) return;
      document.addEventListener('wheel', this.onScrollIntent, { passive: true });
      document.addEventListener('touchmove', this.onScrollIntent, { passive: true });
      document.addEventListener('keydown', this.onScrollIntent);
      window.addEventListener('scroll', this._activateScrollDelay, { passive: true });
    }

    onScrollIntent(event) {
      if (this.popup.contains(event.target) || this.stickyTab?.contains(event.target)) return;
      if (event.type === 'wheel' && !event.deltaY) return;
      if (event.type === 'keydown') {
        if (event.target.closest('input, textarea, select, button, a, [contenteditable]')) return;
        if (!['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', 'Space'].includes(event.code)) return;
      }
      this.scrollIntentUntil = performance.now() + 1500;
    }

    _activateScrollDelay() {
      if (performance.now() > this.scrollIntentUntil || !this.scrollIntentUntil) return;
      super._activateScrollDelay();
    }

    _onScrollDelay() {
      if (this.isDismissed() || this.dataset.autoOpen !== 'true') {
        this.stopAutoOpen();
        return;
      }
      if (performance.now() > this.scrollIntentUntil || !this.scrollIntentUntil) return;
      if (document.body.classList.contains(this.classes.bodyClass)) return;
      super._onScrollDelay();
    }

    stopAutoOpen() {
      window.removeEventListener('scroll', this._activateScrollDelay);
      document.removeEventListener('scroll', this._onScrollDelay);
      document.removeEventListener('wheel', this.onScrollIntent);
      document.removeEventListener('touchmove', this.onScrollIntent);
      document.removeEventListener('keydown', this.onScrollIntent);
      this._scrollDelayActive = false;
      this.scrollIntentUntil = 0;
    }

    isDismissed() {
      if (Shopify?.designMode) return false;
      return Date.now() < this.dismissedUntil || Boolean(this.getCookie(this.dismissalCookie));
    }

    dismiss() {
      if (Shopify?.designMode) return;
      const sixHours = this.dataset.dismissalDuration === '6';
      this.dismissedUntil = sixHours ? Date.now() + 6 * 60 * 60 * 1000 : Infinity;
      document.cookie = `${this.dismissalCookie}=true; path=/; SameSite=Lax${sixHours ? '; max-age=21600' : ''}`;
      this.hasPopupedUp = true;
      this.stopAutoOpen();
      super.closeStickyTab();
    }

    onButtonClick(event) {
      // A close control can only dismiss, even if clicked during a transition.
      if (event.currentTarget.classList.contains('close-popup')) {
        event.preventDefault();
        this.dismiss();
        if (this.popup.classList.contains(this.classes.openClass)) this.closePopup(event);
        return;
      }
      super.onButtonClick(event);
    }

    openPopup() {
      if (this.isDismissed()) return;
      this.stopAutoOpen();
      super.openPopup();
    }

    closePopup(event = {}) {
      if (!this.popup.classList.contains(this.classes.openClass)) return;
      if (event.type === 'click' || event.type === 'keydown') this.dismiss();
      // Cart/editor events close the window without remembering a dismissal.
      super.closePopup(event);
      this.originalSection?.style.removeProperty('z-index');
    }

    openStickyTab() {
      if (this.isDismissed()) {
        super.closeStickyTab();
        return;
      }
      super.openStickyTab();
    }

    closeStickyTab(event) {
      // The inherited controller also calls this when opening the window.
      if (event?.type === 'click') this.dismiss();
      super.closeStickyTab();
    }

    setCookie() {
      // Dismissal uses its own session/6-hour cookie, not FLYOUT's frequency.
    }

    disconnectedCallback() {
      this.stopAutoOpen();
      // FLYOUT moves the window to <body>; clean it up on section unload.
      if (this.popupPlaceholder?.parentNode) {
        this.popup.classList.remove(this.classes.openClass);
        this.popupPlaceholder.parentNode.insertBefore(this.popup, this.popupPlaceholder);
        this.popupPlaceholder.remove();
      }
      super.disconnectedCallback();
    }
  }

  customElements.define('fly-banner', Flybanner);
});
